import React, { useState, useEffect } from 'react';
import PropTpes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import moment from 'moment/moment';
import ContentLoader from '../../atoms/ContentLoader/ContentLoader';
import { addCountryInitAction, fetchCountriesAction } from '../../../actions/countriesActions';
import Modal from '../../Organisms/Modal/Modal';
import AddButton from '../../atoms/AddButton/AddButton';
import ReactiveTable from '../../Organisms/ReactiveTable/ReactiveTable';
import CountryModal from '../../Modals/CountryModal/CountryModal';
import './CountriesPage.scss';

const CountriesPage = ({
  countriesList,
  isLoadingCountries,
  didLoadCountries,
  fetchCountries,
}) => {
  const dispatch = useDispatch();
  const [isModalShown, setIsModalShown] = useState(false);
  const [isCityModalShown, setCityIsModalShown] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(undefined);
  const [selectedCity, setSelectedCity] = useState(undefined);
  useEffect(() => {
    if (selectedCountry !== undefined) {
      setIsModalShown(true);
    } else {
      setIsModalShown(false);
    }
  }, [selectedCountry]);
  useEffect(() => {
    if (selectedCity !== undefined) {
      setCityIsModalShown(true);
    } else {
      setCityIsModalShown(false);
    }
  }, [selectedCity]);
  if (
    (countriesList === undefined || countriesList === null)
    && isLoadingCountries === false
    && didLoadCountries === false
  ) {
    fetchCountries();
  }
  if (isLoadingCountries) {
    return <ContentLoader />;
  }
  const columns = [
    {
      name: 'Code',
      selector: row => row.code,
      sortable: true,
    },
    {
      name: 'Country',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Cities',
      selector: row => row.city.length,
      sortable: true,
    },
  ];
  const cityColumns = [
    {
      name: 'Code',
      selector: row => row.code,
      sortable: true,
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Date Created',
      selector: row => moment(row.created_at).fromNow(),
      sortable: true,
    },
  ];
  const expanded = ({ data }) => (
    <div className="child-table">
      <ReactiveTable
        title={`${data.name} Cities`}
        columns={cityColumns}
        exportableKeys={['name', 'code']}
        fields={['name', 'code']}
        onEdit={(city) => {
          setSelectedCity(city);
          dispatch(fetchCountriesAction());
        }}
        endpoint="types/cities"
        extraParameters={[{ country_id: data.id }]}
      />
    </div>
  );
  return (
    <>
      <div className="col-md-12 header-container">
        <h2>Locations</h2>
        {isModalShown && (
          <Modal
            title={`${!selectedCountry ? 'Add Country' : `Edit ${selectedCountry.name}`}`}
            isShown
            onCloseInvoked={() => setIsModalShown(false)}
          >
            <CountryModal
              onRequestClose={() => {
                setSelectedCountry(undefined);
              }}
              country={selectedCountry}
            />
          </Modal>
        )}
        {isCityModalShown && (
          <Modal
            title={`${!selectedCity ? 'Add Country' : `Edit ${selectedCity.name}`}`}
            isShown
            onCloseInvoked={() => setCityIsModalShown(false)}
          >
            <CountryModal
              onRequestClose={() => {
                setSelectedCity(undefined);
              }}
              country={selectedCity}
            />
          </Modal>
        )}
        {!isModalShown && !isCityModalShown && (
          <div onClick={() => setIsModalShown(true)}>
            <AddButton />
          </div>
        )}
      </div>
      <div className="col-md-12 content-container">
        <ReactiveTable
          columns={columns}
          expandedComponent={expanded}
          isLoading={isLoadingCountries}
          selectableRowDisabledCallback={row => row.city.length === 0}
          endpoint="types/countries"
          onEdit={country => setSelectedCountry(country)}
          exportableKeys={['name', 'code']}
          fields={['name', 'code']}
        />
      </div>
    </>
  );
};

CountriesPage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  countriesList: PropTpes.any.isRequired,
  isLoadingCountries: PropTpes.bool.isRequired,
  didLoadCountries: PropTpes.bool.isRequired,
  fetchCountries: PropTpes.func.isRequired,
};

const mapStateToProps = state => ({
  countriesList: state.countries.countriesList,
  isLoadingCountries: state.countries.isLoadingCountries,
  didLoadCountries: state.countries.didLoadCountries,
  isAddingCountry: state.countries.isAddingCountry,
  didSuccessfullyAddCountry: state.countries.didSuccessfullyAddCountry,
  addCountryError: state.countries.addCountryError,
});

const mapDispatchToProps = dispatch => ({
  fetchCountries: () => dispatch(fetchCountriesAction()),
  addCountry: country => dispatch(addCountryInitAction(country)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CountriesPage);
